import t from "../i18n";
import type { CLIENT_ERROR } from "diagnostics-lib/constants";
type ERROR_TYPE =
  | "network" // fetch failures
  | "contract_failure" // deserialization
  | keyof typeof CLIENT_ERROR
  | "tmp_backend_error" // 502 or 503
  | "backend_error"; // 50*

interface P {
  message?: string;
  debugData?: unknown;
  cause?: unknown;
}

export class ApiError extends Error {
  type: ERROR_TYPE;
  debugData?: unknown;

  constructor(type: ERROR_TYPE, { message, debugData, cause }: P = {}) {
    super(message, { cause });
    this.name = "ApiError";
    this.type = type;
    this.debugData = debugData;
  }
}

export const userMessage = (error: unknown): string => {
  if (error instanceof ApiError) {
    switch (error.type) {
      case "network":
        return t("errors.network");
      case "not_found":
        /**
         * Quick workaround for user not_found in case
         * of Keycloak is created but not in the app
         */
        if (error.message.includes("GET /users/profile")) return t("errors.profile_not_found");
        return t("errors.not_found");
      case "conflict":
        return t("errors.conflict");
      case "unauthorized":
        return t("errors.unauthorized");
      case "forbidden":
        return t("errors.forbidden");
      case "tmp_backend_error":
        return t("errors.tmp_backend_error");
      case "bad_request":
      case "contract_failure":
      case "backend_error":
        return t("errors.backend_error");
      default:
        throw new Error(error.type satisfies never);
    }
  } else {
    return t("errors.unexpected_error");
  }
};
